import { ApiResponse, TokenData, CancellationReason } from '../models';
import * as http from './http';
import ApiService from './service';

export class CancellationReasonService extends ApiService {
  public async loadAllCancellationReason() {
    const url = `${this.apiDomain}/api/settings/order-cancel-reasons`;

    const resposne = await http.get<ApiResponse<CancellationReason[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createCancellationReason(data: CancellationReason, id?: string) {
    const url = `${this.apiDomain}/api/settings/order-cancel-reason`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateCancellationReason(data: CancellationReason, id?: string) {
    const url = `${this.apiDomain}/api/settings/order-cancel-reason/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteCancellationReason(id?: string) {
    const url = `${this.apiDomain}/api/settings/order-cancel-reason/${id}`;

    const response = await http.remove<ApiResponse<CancellationReason>>(
      url,
      this.store
    );
    return response.data;
  }
}
